export function paymentStatusCls(statusName: string): string {
  const s = statusName.toLowerCase();
  if (
    s.includes('не провед') ||
    s.includes('отклон') ||
    s.includes('ошибк') ||
    s.includes('неуспеш') ||
    s.includes('аннул') ||
    s.includes('отмен') ||
    s.includes('должн')
  )
    return 'bg-red-500/10 border-red-500/30 text-red-400';
  if (
    s.includes('подтвержд') ||
    s.includes('успеш') ||
    s.includes('оплач') ||
    s.includes('выполн') ||
    s.includes('провед') ||
    s.includes('зачисл') ||
    s.includes('актив')
  )
    return 'bg-green-500/10 border-green-500/30 text-green-400';
  if (s.includes('ожид') || s.includes('обраб') || s.includes('возврат') || s.includes('провер'))
    return 'bg-yellow-500/10 border-yellow-500/30 text-yellow-400';
  return 'bg-muted/40 border-border/30 text-muted-foreground';
}

// Двухэтапная проверка: сначала явно исключаем неуспешные статусы,
// затем явно включаем успешные. Неизвестный статус → false.
export function isProcessedPayment(statusName: string): boolean {
  const s = statusName.toLowerCase();
  if (
    s.includes('не провед') ||
    s.includes('отклон') ||
    s.includes('ошибк') ||
    s.includes('неуспеш') ||
    s.includes('аннул') ||
    s.includes('отмен')
  )
    return false;
  return (
    s.includes('подтвержд') ||
    s.includes('успеш') ||
    s.includes('оплач') ||
    s.includes('выполн') ||
    s.includes('провед') ||
    s.includes('зачисл') ||
    s.includes('актив')
  );
}
